import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import "../../src/assets/css/style.css";
// import "../../src/assets/css/add-certificate-modern.css";

import footer from "../../src/assets/img/mainfooterbg.png";
import Navbar from "./Navbar";

import {
  getDistrictList,
  getBlockList,
  getGpList,
  getSansadList,
  getVillageList,
  getCertificateDocumentList,
  getCertificateDocumentList2,
  getSubCasteCertificate,
  postCertificate,
} from "../CertificateService";

const EMPTY_OPTION = <option value="">Loading...</option>;

const SectionCard = ({
  number,
  icon,
  title,
  subtitle,
  children,
  className = "",
}) => (
  <section className={`apply-certificate-section ${className}`}>
    <div className="apply-certificate-section-header">
      <div className="apply-certificate-section-icon">
        <span>{number}</span>
        <i className={`fa-solid ${icon}`} />
      </div>

      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>

    <div className="apply-certificate-section-body">{children}</div>
  </section>
);

const FormField = ({
  label,
  required = false,
  hint,
  error,
  fullWidth = false,
  children,
}) => (
  <div
    className={`apply-certificate-field ${fullWidth ? "apply-certificate-field-full" : ""
      }`}
  >
    <label>
      <span>
        {label}
        {required && <b aria-hidden="true">*</b>}
      </span>

      {hint && <small>{hint}</small>}
    </label>

    {children}

    {error && <p className="apply-certificate-inline-error">{error}</p>}
  </div>
);

const CertificateOption = ({
  id,
  title,
  description,
  icon,
  checked,
  disabled = false,
  onChange,
}) => (
  <label
    className={`apply-certificate-option ${checked ? "is-selected" : ""
      } ${disabled ? "is-disabled" : ""}`}
    htmlFor={id}
  >
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />

    <span className="apply-certificate-option-check">
      <i className="fa-solid fa-check" />
    </span>

    <span className="apply-certificate-option-icon">
      <i className={`fa-solid ${icon}`} />
    </span>

    <span className="apply-certificate-option-copy">
      <strong>{title}</strong>
      <small>{description}</small>
    </span>
  </label>
);

const UploadField = ({
  id,
  title,
  note,
  accept,
  fileName,
  onChange,
  required = false,
}) => (
  <div className="apply-certificate-upload">
    <div className="apply-certificate-upload-heading">
      <span>
        {title}
        {required && <b>*</b>}
      </span>
      <small>{note}</small>
    </div>

    <label htmlFor={id} className="apply-certificate-upload-box">
      <input id={id} type="file" accept={accept} onChange={onChange} />

      <span className="apply-certificate-upload-icon">
        <i className="fa-solid fa-cloud-arrow-up" />
      </span>

      <span className="apply-certificate-upload-copy">
        <strong>{fileName || "Choose a file"}</strong>
        <small>
          {fileName ? "Click to replace this file" : "Click to browse from your device"}
        </small>
      </span>
    </label>
  </div>
);

const AddAchievement = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [buttonActive, setButtonActive] = useState(false);

  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [gpList, setGpList] = useState([]);
  const [sansadList, setSansadList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [documentList1, setDocumentList1] = useState([]);
  const [documentList2, setDocumentList2] = useState([]);
  const [subCasteList, setSubCasteList] = useState([]);

  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [gp, setGp] = useState("");
  const [sansad, setSansad] = useState("");
  const [village, setVillage] = useState("");

  const [assesseeNo, setAssesseeNo] = useState("");
  const [assesseeName, setAssesseeName] = useState("");
  const [relation, setRelation] = useState("");

  const [gender, setGender] = useState("");
  const [applicantName, setApplicantName] = useState("");
  const [guardianName, setGuardianName] = useState("");
  const [relationWithGuardian, setRelationWithGuardian] = useState("");
  const [address, setAddress] = useState("");
  const [postOffice, setPostOffice] = useState("");
  const [policeStation, setPoliceStation] = useState("");
  const [pin, setPin] = useState("");
  const [dob, setDob] = useState("");

  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [localApplicantName, setLocalApplicantName] = useState("");
  const [localGuardianName, setLocalGuardianName] = useState("");
  const [localRelation, setLocalRelation] = useState("");
  const [localAddress, setLocalAddress] = useState("");
  const [localPostOffice, setLocalPostOffice] = useState("");
  const [localPoliceStation, setLocalPoliceStation] = useState("");
  const [localVillage, setLocalVillage] = useState("");
  const [localPin, setLocalPin] = useState("");
  const [localDob, setLocalDob] = useState("");

  const [characterCertificate, setCharacterCertificate] = useState(0);
  const [incomeCertificate, setIncomeCertificate] = useState(0);
  const [samePersonCertificate, setSamePersonCertificate] = useState(0);
  const [distanceCertificate, setDistanceCertificate] = useState(0);
  const [casteCertificate, setCasteCertificate] = useState(0);
  const [unmarriedCertificate, setUnmarriedCertificate] = useState(0);

  const [incomeSource, setIncomeSource] = useState("");
  const [annualIncome, setAnnualIncome] = useState("");
  const [distanceFromResidential, setDistanceFromResidential] = useState("");
  const [distanceLocation, setDistanceLocation] = useState("");
  const [samePersonCurrentName, setSamePersonCurrentName] = useState("");
  const [samePersonOldName, setSamePersonOldName] = useState("");

  const [religion, setReligion] = useState("");
  const [caste, setCaste] = useState("");
  const [subCaste, setSubCaste] = useState("");

  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isValidWhatsapp, setIsValidWhatsapp] = useState(true);
  const [emailInput, setEmailInput] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);

  const [document1, setDocument1] = useState("");
  const [document2, setDocument2] = useState("");
  const [uniqueNo1, setUniqueNo1] = useState("");
  const [uniqueNo2, setUniqueNo2] = useState("");
  const [uniqueNo3, setUniqueNo3] = useState("");
  const [gsMemberDocument, setGsMemberDocument] = useState("");

  const [base64String, setBase64String] = useState("");
  const [base64String2, setBase64String2] = useState("");
  const [base64String3, setBase64String3] = useState("");
  const [documentFileName1, setDocumentFileName1] = useState("");
  const [documentFileName2, setDocumentFileName2] = useState("");
  const [documentFileName3, setDocumentFileName3] = useState("");

  const [previewImage, setPreviewImage] = useState("");
  const [photoFileName, setPhotoFileName] = useState("");
  const [photoError, setPhotoError] = useState("");

  const certificate = undefined;

  const matchedSansadNo = useMemo(() => {
    return (
      sansadList.find((item) => String(item.id) === String(sansad))
        ?.SansadNo || ""
    );
  }, [sansad, sansadList]);

  const selectedCertificateCount = [
    characterCertificate,
    incomeCertificate,
    3,
    samePersonCertificate,
    distanceCertificate,
    casteCertificate,
    unmarriedCertificate,
  ].filter(Boolean).length;

  const clearLocalLanguageFields = () => {
    setLocalApplicantName("");
    setLocalGuardianName("");
    setLocalRelation("");
    setLocalAddress("");
    setLocalPostOffice("");
    setLocalPoliceStation("");
    setLocalVillage("");
    setLocalPin("");
    setLocalDob("");
  };

  const selectLanguage = (language) => {
    clearLocalLanguageFields();
    setSelectedLanguage((current) => (current === language ? null : language));
  };

  const loadDocumentOptions = async (overrides = {}) => {
    const selection = {
      character: characterCertificate,
      income: incomeCertificate,
      samePerson: samePersonCertificate,
      distance: distanceCertificate,
      caste: casteCertificate,
      ...overrides,
    };

    try {
      const [firstResult, secondResult] = await Promise.all([
        getCertificateDocumentList(
          selection.character || 0,
          selection.income || 0,
          3,
          selection.samePerson || 0,
          selection.distance || 0,
          selection.caste || 0,
          1
        ),
        getCertificateDocumentList2(
          selection.character || 0,
          selection.income || 0,
          3,
          selection.samePerson || 0,
          selection.distance || 0,
          selection.caste || 0,
          2
        ),
      ]);

      setDocumentList1(Array.isArray(firstResult?.data) ? firstResult.data : []);
      setDocumentList2(
        Array.isArray(secondResult?.data) ? secondResult.data : []
      );
    } catch (error) {
      console.error("Unable to load document lists:", error);
      toast.error("Unable to load the required document list.");
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const storedUser = localStorage.getItem("Certificate_user");
        setUserData(storedUser ? JSON.parse(storedUser) : null);
      } catch (error) {
        console.error("Invalid Certificate_user data:", error);
        toast.error("Unable to read citizen login details.");
      }

      try {
        const districtResult = await getDistrictList();
        setDistrictList(
          Array.isArray(districtResult?.data) ? districtResult.data : []
        );
      } catch (error) {
        console.error("District list error:", error);
        toast.error("Unable to load districts.");
      }

      await loadDocumentOptions({
        character: 0,
        income: 0,
        samePerson: 0,
        distance: 0,
        caste: 0,
      });
    };

    loadInitialData();
    // The initial load must run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDistrictChange = async (event) => {
    const value = event.target.value;

    setDistrict(value);
    setBlock("");
    setGp("");
    setSansad("");
    setVillage("");
    setBlockList([]);
    setGpList([]);
    setSansadList([]);
    setVillageList([]);

    if (!value) return;

    try {
      const result = await getBlockList(value);
      setBlockList(Array.isArray(result?.data) ? result.data : []);
    } catch (error) {
      console.error("Block list error:", error);
      toast.error("Unable to load blocks.");
    }
  };

  const handleBlockChange = async (event) => {
    const value = event.target.value;

    setBlock(value);
    setGp("");
    setSansad("");
    setVillage("");
    setGpList([]);
    setSansadList([]);
    setVillageList([]);

    if (!value) return;

    try {
      const result = await getGpList(value);
      setGpList(Array.isArray(result?.data) ? result.data : []);
    } catch (error) {
      console.error("GP list error:", error);
      toast.error("Unable to load Gram Panchayats.");
    }
  };

  const handleGpChange = async (event) => {
    const value = event.target.value;

    setGp(value);
    setSansad("");
    setVillage("");
    setSansadList([]);
    setVillageList([]);

    if (!value) return;

    try {
      const [sansadResult, villageResult] = await Promise.all([
        getSansadList(value),
        getVillageList(district, block, value),
      ]);

      const rawSansadList = Array.isArray(sansadResult?.data)
        ? sansadResult.data
        : [];

      setSansadList(
        rawSansadList.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
      );

      setVillageList(
        Array.isArray(villageResult?.data) ? villageResult.data : []
      );
    } catch (error) {
      console.error("Sansad/Village list error:", error);
      toast.error("Unable to load Sansad or Village information.");
    }
  };

  const toggleCertificate = (type, checked) => {
    if (type === "character") {
      const nextValue = checked ? 1 : 0;
      setCharacterCertificate(nextValue);
      loadDocumentOptions({ character: nextValue });
    }

    if (type === "income") {
      const nextValue = checked ? 2 : 0;
      setIncomeCertificate(nextValue);
      loadDocumentOptions({ income: nextValue });
    }

    if (type === "samePerson") {
      const nextValue = checked ? 4 : 0;
      setSamePersonCertificate(nextValue);
      loadDocumentOptions({ samePerson: nextValue });
    }

    if (type === "distance") {
      const nextValue = checked ? 5 : 0;
      setDistanceCertificate(nextValue);
      loadDocumentOptions({ distance: nextValue });
    }

    if (type === "caste") {
      const nextValue = checked ? 6 : 0;
      setCasteCertificate(nextValue);
      loadDocumentOptions({ caste: nextValue });
    }

    if (type === "unmarried") {
      setUnmarriedCertificate(checked ? 7 : 0);
    }
  };

  const handleGenderChange = (event) => {
    const value = event.target.value;
    setGender(value);

    if (value === "Mrs.") {
      setUnmarriedCertificate(0);
    }
  };

  const handleCasteChange = async (event) => {
    const value = event.target.value;
    setCaste(value);
    setSubCaste("");
    setSubCasteList([]);

    if (!value) return;

    try {
      const result = await getSubCasteCertificate(value);
      setSubCasteList(Array.isArray(result?.data) ? result.data : []);
    } catch (error) {
      console.error("Sub-caste list error:", error);
      toast.error("Unable to load sub-caste information.");
    }
  };

  const handleWhatsappChange = (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 10);
    setWhatsappNumber(value);
    setIsValidWhatsapp(value === "" || /^[6-9]\d{9}$/.test(value));
  };

  const handleEmailChange = (event) => {
    const value = event.target.value;
    setEmailInput(value);
    setIsValidEmail(
      value === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    );
  };

  const handleEnglishNameChange = (setter) => (event) => {
    const value = event.target.value;

    if (/^[a-zA-Z\s.'-]*$/.test(value)) {
      setter(value);
    }
  };

  const handleNumericChange =
    (setter, maxLength) =>
      (event) => {
        setter(event.target.value.replace(/\D/g, "").slice(0, maxLength));
      };

  const readDocumentFile = (file, setBase64, setFileName) => {
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      toast.error("Document file size must not exceed 2 MB.");
      setBase64("");
      setFileName("");
      return;
    }

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PDF, JPG and JPEG files are allowed.");
      setBase64("");
      setFileName("");
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      setBase64(reader.result);
      setFileName(file.name);
    };

    reader.onerror = () => {
      toast.error("Unable to read the selected document.");
    };

    reader.readAsDataURL(file);
  };

  const handlePhotoUpload = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    if (file.size > 100 * 1024) {
      setPhotoError("Applicant photo must be 100 KB or smaller.");
      setPreviewImage("");
      setPhotoFileName("");
      return;
    }

    if (!["image/jpeg", "image/jpg"].includes(file.type)) {
      setPhotoError("Only JPG or JPEG applicant photos are allowed.");
      setPreviewImage("");
      setPhotoFileName("");
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      setPhotoError("");
      setPreviewImage(reader.result);
      setPhotoFileName(file.name);
    };

    reader.onerror = () => {
      setPhotoError("Unable to read the applicant photo.");
    };

    reader.readAsDataURL(file);
  };

  const validateIdentityDocument = (documentName, number, label) => {
    if (!documentName) {
      toast.error(`Please select ${label}.`);
      return false;
    }

    if (!number) {
      toast.error(`Please enter the number for ${label}.`);
      return false;
    }

    if (documentName === "Aadhaar Card" && number.length !== 12) {
      toast.error(`${label}: Aadhaar number must contain 12 digits.`);
      return false;
    }

    if (documentName === "PAN Card" && number.length !== 10) {
      toast.error(`${label}: PAN number must contain 10 characters.`);
      return false;
    }

    if (
      documentName === "Voter ID Card" &&
      (number.length < 10 || number.length > 20)
    ) {
      toast.error(`${label}: Voter ID must contain 10 to 20 characters.`);
      return false;
    }

    if (documentName === "Driving License" && number.length !== 16) {
      toast.error(`${label}: Driving Licence must contain 16 characters.`);
      return false;
    }

    if (documentName === "Passport" && number.length !== 8) {
      toast.error(`${label}: Passport number must contain 8 characters.`);
      return false;
    }

    return true;
  };

  const validateForm = () => {
    if (!district) return toast.error("Please select District."), false;
    if (!block) return toast.error("Please select Block."), false;
    if (!gp) return toast.error("Please select Gram Panchayat."), false;
    if (!sansad) return toast.error("Please select Sansad."), false;
    if (!village) return toast.error("Please select Village."), false;

    if (!gender) return toast.error("Please select applicant salutation."), false;
    if (!applicantName)
      return toast.error("Please enter applicant name."), false;
    if (!guardianName)
      return toast.error("Please enter guardian name."), false;
    if (!relationWithGuardian)
      return toast.error("Please select relation with guardian."), false;
    if (!address) return toast.error("Please enter address."), false;
    if (!postOffice) return toast.error("Please enter Post Office."), false;
    if (!policeStation)
      return toast.error("Please enter Police Station."), false;
    if (pin.length !== 6)
      return toast.error("PIN code must contain 6 digits."), false;
    if (!dob) return toast.error("Please select date of birth."), false;

    if (selectedLanguage) {
      const localizedFields = [
        localApplicantName,
        localGuardianName,
        localRelation,
        localAddress,
        localPostOffice,
        localPoliceStation,
        localVillage,
        localPin,
        localDob,
      ];

      if (localizedFields.some((field) => !field)) {
        toast.error(
          `Please complete all ${selectedLanguage === "B" ? "Bengali" : "Nepali"
          } fields.`
        );
        return false;
      }
    }

    if (incomeCertificate && (!incomeSource || !annualIncome)) {
      toast.error("Please complete all Income Certificate details.");
      return false;
    }

    if (
      distanceCertificate &&
      (!distanceFromResidential || !distanceLocation)
    ) {
      toast.error("Please complete all Distance Certificate details.");
      return false;
    }

    if (casteCertificate && (!religion || !caste || !subCaste)) {
      toast.error("Please complete all Caste Certificate details.");
      return false;
    }

    if (
      samePersonCertificate &&
      (!samePersonCurrentName || !samePersonOldName)
    ) {
      toast.error("Please complete all Same Person Certificate details.");
      return false;
    }

    if (!userData?.mobile || String(userData.mobile).length !== 10) {
      toast.error("Registered mobile number must contain 10 digits.");
      return false;
    }

    if (!isValidWhatsapp) {
      toast.error("Please enter a valid WhatsApp number.");
      return false;
    }

    if (!isValidEmail) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    if (!validateIdentityDocument(document1, uniqueNo1, "Document 1")) {
      return false;
    }

    if (!base64String) {
      toast.error("Please upload Document 1.");
      return false;
    }

    if (!validateIdentityDocument(document2, uniqueNo2, "Document 2")) {
      return false;
    }

    if (!base64String2) {
      toast.error("Please upload Document 2.");
      return false;
    }

    if (!previewImage) {
      toast.error("Please upload the applicant photo.");
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    setButtonActive(true);

    try {
      postCertificate(
        district,
        block,
        gp,
        matchedSansadNo,
        assesseeNo,
        assesseeName,
        applicantName,
        relation,
        guardianName,
        relationWithGuardian,
        address,
        policeStation,
        postOffice,
        village,
        pin,
        dob,
        gender,
        certificate,
        userData?.mobile,
        whatsappNumber,
        emailInput,
        characterCertificate || 0,
        incomeCertificate || 0,
        3,
        samePersonCertificate || 0,
        distanceCertificate || 0,
        incomeSource,
        annualIncome,
        distanceFromResidential,
        distanceLocation,
        samePersonOldName,
        samePersonCurrentName,
        document1,
        uniqueNo1,
        base64String,
        document2,
        uniqueNo2,
        base64String2,
        previewImage,
        localApplicantName,
        localGuardianName,
        localRelation,
        localAddress,
        localPostOffice,
        localPoliceStation,
        localVillage,
        localPin,
        localDob,
        casteCertificate || 0,
        religion,
        caste,
        subCaste,
        uniqueNo3,
        base64String3,
        selectedLanguage,
        unmarriedCertificate || 0,
        (response) => {
          if (response?.StatusCode === 0) {
            toast.success("Certificate application submitted successfully.");
            navigate("/certificate-list");
            return;
          }

          setButtonActive(false);

          if (response?.StatusCode === 1) {
            toast.error(response?.StatusMsg || "Unable to submit application.");
            return;
          }

          toast.error("Unable to submit the certificate application.");
        }
      );
    } catch (error) {
      console.error("Certificate submission error:", error);
      setButtonActive(false);
      toast.error("Something went wrong while submitting the application.");
    }
  };

  const handleReset = () => {
    window.location.reload();
  };

  const languagePlaceholder = (bengaliText, nepaliText) => {
    if (!selectedLanguage) {
      return "Select Bengali or Nepali above";
    }

    return selectedLanguage === "B" ? bengaliText : nepaliText;
  };

  return (
    <div className="apply-certificate-page">
      <ToastContainer
        position="top-right"
        autoClose={3500}
        newestOnTop
        closeOnClick
        pauseOnHover
      />

      <Navbar />

      <main className="apply-certificate-main">
        <section className="apply-certificate-hero">
          <div className="apply-certificate-hero-content">
            <button
              type="button"
              className="apply-certificate-back"
              onClick={() => navigate("/certificate-list")}
            >
              <i className="fa-solid fa-arrow-left" />
              Back to applications
            </button>

            <div className="apply-certificate-hero-title">
              <span className="apply-certificate-hero-icon">
                <i className="fa-solid fa-file-signature" />
              </span>

              <div>
                <p>Citizen Corner</p>
                <h1>Application Form for Certificate</h1>
                <span>
                  Complete all mandatory fields and upload clear supporting
                  documents.
                </span>
              </div>
            </div>
          </div>

          <div className="apply-certificate-hero-status">
            <span>
              <i className="fa-solid fa-shield-halved" />
              Secure application
            </span>
            <span>
              <i className="fa-solid fa-mobile-screen-button" />
              Mobile: {userData?.mobile || "Not available"}
            </span>
          </div>
        </section>

        {/* <div className="apply-certificate-step-strip">
          {[
            ["1", "Location", "fa-location-dot"],
            ["2", "Applicant", "fa-user"],
            ["3", "Certificate", "fa-certificate"],
            ["4", "Documents", "fa-folder-open"],
          ].map(([number, title, icon]) => (
            <div key={number}>
              <span>
                <i className={`fa-solid ${icon}`} />
              </span>
              <strong>{number}. {title}</strong>
            </div>
          ))}
        </div> */}


        <div
          className="apply-certificate-process-flow"
          aria-label="Certificate application form sections"
        >
          <div className="apply-certificate-process-step">
            <span className="apply-certificate-process-number">Step 1</span>

            <div className="apply-certificate-process-content">
              <i className="fa-solid fa-location-dot" />

              <div>
                <strong>Location Details</strong>
                <small>District, Block, GP and Village</small>
              </div>
            </div>
          </div>

          <div className="apply-certificate-process-arrow" aria-hidden="true">
            <i className="fa-solid fa-arrow-right-long" />
          </div>

          <div className="apply-certificate-process-step">
            <span className="apply-certificate-process-number">Step 2</span>

            <div className="apply-certificate-process-content">
              <i className="fa-solid fa-user" />

              <div>
                <strong>Applicant Details</strong>
                <small>Personal and address information</small>
              </div>
            </div>
          </div>

          <div className="apply-certificate-process-arrow" aria-hidden="true">
            <i className="fa-solid fa-arrow-right-long" />
          </div>

          <div className="apply-certificate-process-step">
            <span className="apply-certificate-process-number">Step 3</span>

            <div className="apply-certificate-process-content">
              <i className="fa-solid fa-certificate" />

              <div>
                <strong>Select Certificate</strong>
                <small>Choose required certificate types</small>
              </div>
            </div>
          </div>

          <div className="apply-certificate-process-arrow" aria-hidden="true">
            <i className="fa-solid fa-arrow-right-long" />
          </div>

          <div className="apply-certificate-process-step">
            <span className="apply-certificate-process-number">Step 4</span>

            <div className="apply-certificate-process-content">
              <i className="fa-solid fa-folder-open" />

              <div>
                <strong>Upload Documents</strong>
                <small>Attach documents and photograph</small>
              </div>
            </div>
          </div>
        </div>

        <form
          className="apply-certificate-form"
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmit();
          }}
        >
          <SectionCard
            number="01"
            icon="fa-map-location-dot"
            title="Gram Panchayat Details"
            subtitle="Select the applicant's administrative location."
          >
            <div className="apply-certificate-grid">
              <FormField label="District" required>
                <select value={district} onChange={handleDistrictChange}>
                  <option value="">Select District</option>
                  {districtList.length
                    ? districtList.map((item) => (
                      <option key={item.DIST_LGD} value={item.DIST_LGD}>
                        {item.DIST_NAME}
                      </option>
                    ))
                    : EMPTY_OPTION}
                </select>
              </FormField>

              <FormField label="Block" required>
                <select
                  value={block}
                  onChange={handleBlockChange}
                  disabled={!district}
                >
                  <option value="">Select Block</option>
                  {blockList.map((item) => (
                    <option key={item.BLOCK_LGD} value={item.BLOCK_LGD}>
                      {item.BLOCK_NAME}
                    </option>
                  ))}
                </select>
              </FormField>

              <FormField label="Gram Panchayat" required>
                <select value={gp} onChange={handleGpChange} disabled={!block}>
                  <option value="">Select Gram Panchayat</option>
                  {gpList.map((item) => (
                    <option key={item.GP_LGD} value={item.GP_LGD}>
                      {item.GP_NAME}
                    </option>
                  ))}
                </select>
              </FormField>

              <FormField label="Sansad" required>
                <select
                  value={sansad}
                  onChange={(event) => setSansad(event.target.value)}
                  disabled={!gp}
                >
                  <option value="">Select Sansad</option>
                  {sansadList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.Sansad}
                      {item.memberName ? ` - ${item.memberName}` : ""}
                    </option>
                  ))}
                </select>
              </FormField>

              <FormField label="Village" required>
                <select
                  value={village}
                  onChange={(event) => setVillage(event.target.value)}
                  disabled={!gp}
                >
                  <option value="">Select Village</option>
                  {villageList.map((item) => (
                    <option key={item.VILL_LGD} value={item.VILL_LGD}>
                      {item.VILL_NAME}
                    </option>
                  ))}
                </select>
              </FormField>

              <FormField label="Assessee Number" hint="Optional">
                <input
                  type="text"
                  value={assesseeNo}
                  placeholder="Enter assessee number"
                  onChange={(event) => setAssesseeNo(event.target.value)}
                />
              </FormField>

              <FormField label="Assessee Name" hint="Optional">
                <input
                  type="text"
                  value={assesseeName}
                  placeholder="Enter assessee name"
                  onChange={handleEnglishNameChange(setAssesseeName)}
                />
              </FormField>

              <FormField label="Relation with Applicant" hint="Optional">
                <input
                  type="text"
                  value={relation}
                  placeholder="Enter relationship"
                  onChange={handleEnglishNameChange(setRelation)}
                />
              </FormField>
            </div>
          </SectionCard>

          <SectionCard
            number="02"
            icon="fa-address-card"
            title="Applicant Details"
            subtitle="Enter the applicant's personal and address information."
          >
            <div className="apply-certificate-language-panel">
              <div>
                <i className="fa-solid fa-language" />
                <span>
                  <strong>Additional certificate language</strong>
                  <small>
                    English details are mandatory. Choose Bengali or Nepali only
                    when an additional translated certificate is required.
                  </small>
                </span>
              </div>

              <div className="apply-certificate-language-buttons">
                <button
                  type="button"
                  className={!selectedLanguage ? "is-active" : ""}
                  onClick={() => {
                    clearLocalLanguageFields();
                    setSelectedLanguage(null);
                  }}
                >
                  English only
                </button>

                <button
                  type="button"
                  className={selectedLanguage === "B" ? "is-active" : ""}
                  onClick={() => selectLanguage("B")}
                >
                  বাংলা
                </button>

                <button
                  type="button"
                  className={selectedLanguage === "N" ? "is-active" : ""}
                  onClick={() => selectLanguage("N")}
                >
                  नेपाली
                </button>
              </div>
            </div>

            <div className="apply-certificate-dual-heading">
              <span>
                <i className="fa-solid fa-font" />
                English details
              </span>
              <span className={!selectedLanguage ? "is-muted" : ""}>
                <i className="fa-solid fa-language" />
                {selectedLanguage === "B"
                  ? "Bengali details"
                  : selectedLanguage === "N"
                    ? "Nepali details"
                    : "Translated details"}
              </span>
            </div>

            <div className="apply-certificate-grid">
              <FormField label="Salutation" required>
                <select value={gender} onChange={handleGenderChange}>
                  <option value="">Select Salutation</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Miss">Miss</option>
                </select>
              </FormField>

              <FormField label="Translated salutation">
                <input
                  type="text"
                  disabled
                  placeholder={
                    selectedLanguage
                      ? "Salutation follows the English selection"
                      : "Select a language above"
                  }
                />
              </FormField>

              <FormField label="Applicant Name" required>
                <input
                  type="text"
                  value={applicantName}
                  placeholder="Enter applicant name"
                  onChange={handleEnglishNameChange(setApplicantName)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "আবেদনকারীর নাম"
                    : selectedLanguage === "N"
                      ? "आवेदकको नाम"
                      : "Translated Applicant Name"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localApplicantName}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "আবেদনকারীর নাম লিখুন",
                    "आवेदकको नाम लेख्नुहोस्"
                  )}
                  onChange={(event) => setLocalApplicantName(event.target.value)}
                />
              </FormField>

              <FormField label="Guardian Name" required>
                <input
                  type="text"
                  value={guardianName}
                  placeholder="Enter guardian name"
                  onChange={handleEnglishNameChange(setGuardianName)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "অভিভাবকের নাম"
                    : selectedLanguage === "N"
                      ? "अभिभावकको नाम"
                      : "Translated Guardian Name"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localGuardianName}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "অভিভাবকের নাম লিখুন",
                    "अभिभावकको नाम लेख्नुहोस्"
                  )}
                  onChange={(event) => setLocalGuardianName(event.target.value)}
                />
              </FormField>

              <FormField label="Relation with Guardian" required>
                <select
                  value={relationWithGuardian}
                  onChange={(event) =>
                    setRelationWithGuardian(event.target.value)
                  }
                >
                  <option value="">Select Relation</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Husband">Husband</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Legal Guardian">Legal Guardian</option>
                </select>
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "অভিভাবকের সাথে সম্পর্ক"
                    : selectedLanguage === "N"
                      ? "अभिभावकसँगको सम्बन्ध"
                      : "Translated Relation"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localRelation}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "সম্পর্ক লিখুন",
                    "सम्बन्ध लेख्नुहोस्"
                  )}
                  onChange={(event) => setLocalRelation(event.target.value)}
                />
              </FormField>

              <FormField label="Address" required>
                <textarea
                  rows="3"
                  value={address}
                  placeholder="Enter complete address"
                  onChange={(event) => setAddress(event.target.value)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "ঠিকানা"
                    : selectedLanguage === "N"
                      ? "ठेगाना"
                      : "Translated Address"
                }
                required={Boolean(selectedLanguage)}
              >
                <textarea
                  rows="3"
                  value={localAddress}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "সম্পূর্ণ ঠিকানা লিখুন",
                    "पूरा ठेगाना लेख्नुहोस्"
                  )}
                  onChange={(event) => setLocalAddress(event.target.value)}
                />
              </FormField>

              <FormField label="Post Office" required>
                <input
                  type="text"
                  value={postOffice}
                  placeholder="Enter Post Office"
                  onChange={(event) => setPostOffice(event.target.value)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "ডাকঘর"
                    : selectedLanguage === "N"
                      ? "हुलाक कार्यालय"
                      : "Translated Post Office"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localPostOffice}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "ডাকঘরের নাম লিখুন",
                    "हुलाक कार्यालय लेख्नुहोस्"
                  )}
                  onChange={(event) => setLocalPostOffice(event.target.value)}
                />
              </FormField>

              <FormField label="Police Station" required>
                <input
                  type="text"
                  value={policeStation}
                  placeholder="Enter Police Station"
                  onChange={(event) => setPoliceStation(event.target.value)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "থানা"
                    : selectedLanguage === "N"
                      ? "प्रहरी चौकी"
                      : "Translated Police Station"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localPoliceStation}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "থানার নাম লিখুন",
                    "प्रहरी चौकी लेख्नुहोस्"
                  )}
                  onChange={(event) =>
                    setLocalPoliceStation(event.target.value)
                  }
                />
              </FormField>

              <FormField label="PIN Code" required>
                <input
                  type="text"
                  inputMode="numeric"
                  value={pin}
                  maxLength={6}
                  placeholder="6-digit PIN"
                  onChange={handleNumericChange(setPin, 6)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "পিন"
                    : selectedLanguage === "N"
                      ? "पिन"
                      : "Translated PIN"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  inputMode="numeric"
                  value={localPin}
                  maxLength={6}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "৬ সংখ্যার পিন",
                    "६ अङ्कको पिन"
                  )}
                  onChange={handleNumericChange(setLocalPin, 6)}
                />
              </FormField>

              <FormField label="Date of Birth" required>
                <input
                  type="date"
                  value={dob}
                  onChange={(event) => setDob(event.target.value)}
                />
              </FormField>

              <FormField
                label={
                  selectedLanguage === "B"
                    ? "জন্ম তারিখ"
                    : selectedLanguage === "N"
                      ? "जन्म मिति"
                      : "Translated Date of Birth"
                }
                required={Boolean(selectedLanguage)}
              >
                <input
                  type="text"
                  value={localDob}
                  disabled={!selectedLanguage}
                  placeholder={languagePlaceholder(
                    "ইংরেজি বছর অনুযায়ী জন্ম তারিখ",
                    "अंग्रेजी वर्ष अनुसार जन्म मिति"
                  )}
                  onChange={(event) => setLocalDob(event.target.value)}
                />
              </FormField>
            </div>
          </SectionCard>

          <SectionCard
            number="03"
            icon="fa-certificate"
            title="Certificate Selection"
            subtitle="Residential Certificate is included by default. We can Choose more than one."
          >
            <div className="apply-certificate-selection-summary">
              <span>
                <i className="fa-solid fa-layer-group" />
                {selectedCertificateCount} certificate type
                {selectedCertificateCount !== 1 ? "s" : ""} selected
              </span>
              <small>
                Required document lists update automatically when selections
                change.
              </small>
            </div>

            <div className="apply-certificate-options">
              <CertificateOption
                id="certificate-character"
                title="Character Certificate"
                description="Certificate regarding conduct and character."
                icon="fa-user-shield"
                checked={Boolean(characterCertificate)}
                onChange={(event) =>
                  toggleCertificate("character", event.target.checked)
                }
              />

              <CertificateOption
                id="certificate-income"
                title="Income Certificate"
                description="Certificate declaring annual family income."
                icon="fa-indian-rupee-sign"
                checked={Boolean(incomeCertificate)}
                onChange={(event) =>
                  toggleCertificate("income", event.target.checked)
                }
              />

              <CertificateOption
                id="certificate-residential"
                title="Residential Certificate"
                description="Included automatically with this application."
                icon="fa-house-circle-check"
                checked
                disabled
                onChange={() => { }}
              />

              <CertificateOption
                id="certificate-distance"
                title="Distance Certificate"
                description="Certificate for distance from residence."
                icon="fa-route"
                checked={Boolean(distanceCertificate)}
                onChange={(event) =>
                  toggleCertificate("distance", event.target.checked)
                }
              />

              <CertificateOption
                id="certificate-caste"
                title="Caste Certificate"
                description="Certificate for caste and sub-caste details."
                icon="fa-people-group"
                checked={Boolean(casteCertificate)}
                onChange={(event) =>
                  toggleCertificate("caste", event.target.checked)
                }
              />

              <CertificateOption
                id="certificate-same-person"
                title="Same Person Certificate"
                description="Links an old name and current name."
                icon="fa-id-card"
                checked={Boolean(samePersonCertificate)}
                onChange={(event) =>
                  toggleCertificate("samePerson", event.target.checked)
                }
              />

              <CertificateOption
                id="certificate-unmarried"
                title="Unmarried Certificate"
                description={
                  gender === "Mrs."
                    ? "Unavailable when salutation is Mrs."
                    : "Certificate confirming unmarried status."
                }
                icon="fa-ring"
                checked={Boolean(unmarriedCertificate)}
                disabled={gender === "Mrs."}
                onChange={(event) =>
                  toggleCertificate("unmarried", event.target.checked)
                }
              />
            </div>

            {(incomeCertificate ||
              distanceCertificate ||
              casteCertificate ||
              samePersonCertificate) && (
                <div className="apply-certificate-conditional-area">
                  {incomeCertificate ? (
                    <div className="apply-certificate-subsection">
                      <div className="apply-certificate-subsection-title">
                        <i className="fa-solid fa-indian-rupee-sign" />
                        <span>
                          <strong>Income Certificate Details</strong>
                          <small>Provide annual income and its source.</small>
                        </span>
                      </div>

                      <div className="apply-certificate-grid">
                        <FormField label="Annual Family Income" required>
                          <input
                            type="text"
                            inputMode="numeric"
                            value={annualIncome}
                            placeholder="Enter annual income"
                            onChange={handleNumericChange(setAnnualIncome, 12)}
                          />
                        </FormField>

                        <FormField label="Source of Income" required>
                          <input
                            type="text"
                            value={incomeSource}
                            placeholder="For example: Agriculture"
                            onChange={(event) => setIncomeSource(event.target.value)}
                          />
                        </FormField>
                      </div>
                    </div>
                  ) : null}

                  {distanceCertificate ? (
                    <div className="apply-certificate-subsection">
                      <div className="apply-certificate-subsection-title">
                        <i className="fa-solid fa-route" />
                        <span>
                          <strong>Distance Certificate Details</strong>
                          <small>Provide distance and destination.</small>
                        </span>
                      </div>

                      <div className="apply-certificate-grid">
                        <FormField
                          label="Distance from Residence (KM)"
                          required
                        >
                          <input
                            type="text"
                            inputMode="decimal"
                            value={distanceFromResidential}
                            placeholder="Enter distance in KM"
                            onChange={(event) =>
                              setDistanceFromResidential(
                                event.target.value.replace(/[^0-9.]/g, "")
                              )
                            }
                          />
                        </FormField>

                        <FormField label="Destination / Location" required>
                          <input
                            type="text"
                            value={distanceLocation}
                            placeholder="Enter destination"
                            onChange={(event) =>
                              setDistanceLocation(event.target.value)
                            }
                          />
                        </FormField>
                      </div>
                    </div>
                  ) : null}

                  {casteCertificate ? (
                    <div className="apply-certificate-subsection">
                      <div className="apply-certificate-subsection-title">
                        <i className="fa-solid fa-people-group" />
                        <span>
                          <strong>Caste Certificate Details</strong>
                          <small>Select religion, caste and sub-caste.</small>
                        </span>
                      </div>

                      <div className="apply-certificate-grid apply-certificate-grid-three">
                        <FormField label="Religion" required>
                          <select
                            value={religion}
                            onChange={(event) => setReligion(event.target.value)}
                          >
                            <option value="">Select Religion</option>
                            <option value="Hinduism">Hinduism</option>
                            <option value="Islam">Islam</option>
                            <option value="Christianity">Christianity</option>
                            <option value="Sikhism">Sikhism</option>
                            <option value="Buddhism">Buddhism</option>
                            <option value="Animism/Adivasi">
                              Animism/Adivasi
                            </option>
                            <option value="Jainism">Jainism</option>
                            <option value="No religion">No religion</option>
                            <option value="Others">Others</option>
                          </select>
                        </FormField>

                        <FormField label="Caste" required>
                          <select value={caste} onChange={handleCasteChange}>
                            <option value="">Select Caste</option>
                            <option value="1">General</option>
                            <option value="2">SC</option>
                            <option value="3">ST</option>
                            {/* <option value="4">OBC-A</option>
                          <option value="5">OBC-B</option> */}
                            <option value="6">OBC</option>
                          </select>
                        </FormField>

                        <FormField label="Sub-caste" required>
                          <select
                            value={subCaste}
                            onChange={(event) => setSubCaste(event.target.value)}
                            disabled={!caste}
                          >
                            <option value="">Select Sub-caste</option>
                            {subCasteList.map((item, index) => (
                              <option
                                key={`${item.SubCastName}-${index}`}
                                value={item.SubCastName}
                              >
                                {item.SubCastName}
                              </option>
                            ))}
                          </select>
                        </FormField>
                      </div>
                    </div>
                  ) : null}

                  {samePersonCertificate ? (
                    <div className="apply-certificate-subsection">
                      <div className="apply-certificate-subsection-title">
                        <i className="fa-solid fa-id-card" />
                        <span>
                          <strong>Same Person Certificate Details</strong>
                          <small>Provide the previous and current names.</small>
                        </span>
                      </div>

                      <div className="apply-certificate-grid">
                        <FormField label="Previous / Old Name" required>
                          <input
                            type="text"
                            value={samePersonOldName}
                            placeholder="Enter previous name"
                            onChange={handleEnglishNameChange(
                              setSamePersonOldName
                            )}
                          />
                        </FormField>

                        <FormField label="Current Name" required>
                          <input
                            type="text"
                            value={samePersonCurrentName}
                            placeholder="Enter current name"
                            onChange={handleEnglishNameChange(
                              setSamePersonCurrentName
                            )}
                          />
                        </FormField>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
          </SectionCard>

          <SectionCard
            number="04"
            icon="fa-address-book"
            title="Contact Information"
            subtitle="Application updates may be sent using these details."
          >
            <div className="apply-certificate-grid apply-certificate-grid-three">
              <FormField label="Registered Mobile Number" required>
                <div className="apply-certificate-input-icon">
                  <i className="fa-solid fa-mobile-screen-button" />
                  <input
                    type="text"
                    value={userData?.mobile || ""}
                    disabled
                    placeholder="Registered mobile number"
                  />
                </div>
              </FormField>

              <FormField
                label="WhatsApp Number"
                error={
                  !isValidWhatsapp
                    ? "Enter a valid 10-digit Indian mobile number."
                    : ""
                }
              >
                <div className="apply-certificate-input-icon">
                  <i className="fa-brands fa-whatsapp" />
                  <input
                    type="text"
                    inputMode="numeric"
                    value={whatsappNumber}
                    maxLength={10}
                    placeholder="Optional WhatsApp number"
                    onChange={handleWhatsappChange}
                  />
                </div>
              </FormField>

              <FormField
                label="Email Address"
                error={!isValidEmail ? "Enter a valid email address." : ""}
              >
                <div className="apply-certificate-input-icon">
                  <i className="fa-solid fa-envelope" />
                  <input
                    type="email"
                    value={emailInput}
                    placeholder="Optional email address"
                    onChange={handleEmailChange}
                  />
                </div>
              </FormField>
            </div>
          </SectionCard>

          <SectionCard
            number="05"
            icon="fa-folder-open"
            title="Supporting Documents"
            subtitle="Upload clear and readable documents. Each supporting document may be up to 2 MB."
          >
            <div className="apply-certificate-document-card">
              <div className="apply-certificate-document-number">1</div>

              <div className="apply-certificate-document-fields">
                <div className="apply-certificate-grid apply-certificate-grid-document">
                  <FormField label="Select Document 1" required>
                    <select
                      value={document1}
                      onChange={(event) => setDocument1(event.target.value)}
                    >
                      <option value="">Select Document</option>
                      {documentList1.map((item, index) => (
                        <option
                          key={`${item.DOCUMENT_NAME}-${index}`}
                          value={item.DOCUMENT_NAME}
                        >
                          {item.DOCUMENT_NAME}
                        </option>
                      ))}
                    </select>
                  </FormField>

                  <FormField label="Document Number 1" required>
                    <input
                      type="text"
                      value={uniqueNo1}
                      placeholder="Enter document number"
                      onChange={(event) => setUniqueNo1(event.target.value)}
                    />
                  </FormField>

                  <UploadField
                    id="supporting-document-1"
                    title="Upload Document 1"
                    note="PDF, JPG or JPEG — maximum 2 MB"
                    accept=".pdf,.jpg,.jpeg"
                    required
                    fileName={documentFileName1}
                    onChange={(event) =>
                      readDocumentFile(
                        event.target.files?.[0],
                        setBase64String,
                        setDocumentFileName1
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="apply-certificate-document-card">
              <div className="apply-certificate-document-number">2</div>

              <div className="apply-certificate-document-fields">
                <div className="apply-certificate-grid apply-certificate-grid-document">
                  <FormField label="Select Document 2" required>
                    <select
                      value={document2}
                      onChange={(event) => setDocument2(event.target.value)}
                    >
                      <option value="">Select Document</option>
                      {documentList2.map((item, index) => (
                        <option
                          key={`${item.DOCUMENT_NAME}-${index}`}
                          value={item.DOCUMENT_NAME}
                        >
                          {item.DOCUMENT_NAME}
                        </option>
                      ))}
                    </select>
                  </FormField>

                  <FormField label="Document Number 2" required>
                    <input
                      type="text"
                      value={uniqueNo2}
                      placeholder="Enter document number"
                      onChange={(event) => setUniqueNo2(event.target.value)}
                    />
                  </FormField>

                  <UploadField
                    id="supporting-document-2"
                    title="Upload Document 2"
                    note="PDF, JPG or JPEG — maximum 2 MB"
                    accept=".pdf,.jpg,.jpeg"
                    required
                    fileName={documentFileName2}
                    onChange={(event) =>
                      readDocumentFile(
                        event.target.files?.[0],
                        setBase64String2,
                        setDocumentFileName2
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="apply-certificate-document-card is-optional">
              <div className="apply-certificate-document-number">3</div>

              <div className="apply-certificate-document-fields">
                <div className="apply-certificate-grid apply-certificate-grid-document">
                  <FormField
                    label="GS Member Certificate / Other Document"
                    hint="Optional"
                  >
                    <select
                      value={gsMemberDocument}
                      onChange={(event) =>
                        setGsMemberDocument(event.target.value)
                      }
                    >
                      <option value="">Select Optional Document</option>
                      <option value="GS Member Certificate">
                        GS Member Certificate
                      </option>
                      <option value="Other Related Document">
                        Other Related Document
                      </option>
                    </select>
                  </FormField>

                  <FormField label="Document Number" hint="Optional">
                    <input
                      type="text"
                      value={uniqueNo3}
                      placeholder="Enter document number"
                      onChange={(event) => setUniqueNo3(event.target.value)}
                    />
                  </FormField>

                  <UploadField
                    id="supporting-document-3"
                    title="Upload Optional Document"
                    note="PDF, JPG or JPEG — maximum 2 MB"
                    accept=".pdf,.jpg,.jpeg"
                    fileName={documentFileName3}
                    onChange={(event) =>
                      readDocumentFile(
                        event.target.files?.[0],
                        setBase64String3,
                        setDocumentFileName3
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="apply-certificate-photo-panel">
              <div className="apply-certificate-photo-copy">
                <span className="apply-certificate-photo-icon">
                  <i className="fa-solid fa-camera" />
                </span>

                <div>
                  <h3>
                    Applicant Photograph <b>*</b>
                  </h3>
                  <p>
                    Upload a recent JPG or JPEG photograph. The maximum permitted
                    size is 100 KB.
                  </p>
                </div>
              </div>

              <div className="apply-certificate-photo-control">
                {previewImage ? (
                  <img src={previewImage} alt="Applicant preview" />
                ) : (
                  <span className="apply-certificate-photo-placeholder">
                    <i className="fa-solid fa-user" />
                  </span>
                )}

                <label htmlFor="applicant-photo">
                  <input
                    id="applicant-photo"
                    type="file"
                    accept=".jpg,.jpeg"
                    onChange={handlePhotoUpload}
                  />

                  <i className="fa-solid fa-camera-retro" />
                  {photoFileName || "Choose applicant photo"}
                </label>

                {photoError && (
                  <p className="apply-certificate-inline-error">{photoError}</p>
                )}
              </div>
            </div>
          </SectionCard>

          <section className="apply-certificate-confirmation">
            <div>
              <span>
                <i className="fa-solid fa-circle-info" />
              </span>

              <p>
                <strong>Review before submitting</strong>
                Please verify all names, location details, certificate
                selections and uploaded documents. Incorrect information may
                delay approval.
              </p>
            </div>

            <div className="apply-certificate-actions">
              <button
                type="button"
                className="apply-certificate-reset-button"
                onClick={handleReset}
                disabled={buttonActive}
              >
                <i className="fa-solid fa-arrow-rotate-left" />
                Reset Form
              </button>

              <button
                type="submit"
                className="apply-certificate-submit-button"
                disabled={buttonActive}
              >
                {buttonActive ? (
                  <>
                    <span className="apply-certificate-button-loader" />
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-paper-plane" />
                    Submit Application
                  </>
                )}
              </button>
            </div>
          </section>
        </form>
      </main>

      <footer className="apply-certificate-footer">
        <img src={footer} alt="" aria-hidden="true" />

        <div>
          <p>
            <strong>© 2024</strong> Designed and Developed by{" "}
            <b>IT and Statistical Cell</b>, Panchayat &amp; Rural Development
            Department, <b>Government of West Bengal</b>
          </p>

          <p>
            Best viewed at 1920 × 1080 resolution using a recent version of
            Google Chrome, Mozilla Firefox, Microsoft Edge or Safari.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AddAchievement;
